import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useLocation } from "react-router";
import documents from "../assets/images/documents.png";
import { useNavigate } from "react-router-dom";
import back from "../assets/images/back_arrow.png";
import deleteicon from "../assets/images/delete-icon.jpg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { FcImageFile } from "react-icons/fc";
import { AiFillFilePdf } from "react-icons/ai";
import plus from "../assets/images/plus.png";
import $ from "jquery";
import Spinner from "../components/Spinner";
import { message } from 'antd'

const moment = require("moment");
const ViewMedicalRecords = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [uploadedFile, setUploadedFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoFile, setIsNoFile] = useState(false);
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isDeleteDoc, setIsDeleteDoc] = useState(false);
  const [uploadedDocId, setUploadedDocId] = useState("");
  const [refreshUploadedDoc, setRefreshUploadedDoc] = useState(false);
  const [folderDetails, setFolderDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [img, setImg] = useState("");
  const [fileType, setFileType] = useState("");

  let id = location.state.id;
  let patientUniqueId = localStorage.getItem("patientUniqueId");
  console.log(patientUniqueId);
  console.log(id);

  useEffect(() => {

    const getUploadFolder = async () => {
      const token = localStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
      };
      setIsOpenCollapse(true);
      setIsLoading(true);
      setUploadedFile([]);
      let isMessageShown = false;

      try {

        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/get_single_uploaded_file_by_folder_id?folder_id=${id}&MDT=PM&user_role=rp`,
          { headers }
        );
        console.log(" uploaded file success response ", response.data);
        setIsLoading(false);
        setSpinner(false);

        if (response.data.status == "1") {
          setFolderDetails(response.data.data);
        } else if (response.data.status == '0') {
          logoutHandler();
        }

      } catch (error) {
        if (!isMessageShown) {
          if (error.response && error.response.status == '401') {
            console.error("Unauthorized access. Logging out.");
            message.error(error.response.data?.message || 'Unauthorized');
            logoutHandler();
          } else {
            console.error("Error:", error.message);
            message.error('An error occurred. Please try again.');
          }
          isMessageShown = true;
        }
      }

      try {

        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/get_uploaded_file_by_folder_id?folder_id=${id}&MDT=PM&user_role=rp`,
          { headers }
        );

        console.log(" uploaded file success response ", response.data);
        setIsLoading(false);
        setSpinner(false);

        if (response.data.status == "1") {
          if (response.data.data?.length > 0) {
            setIsNoFile(false);
            setUploadedFile(response.data?.data);
          } else {
            setIsNoFile(true);
          }
        } else if (response.data?.status == '401') {
          logoutHandler();
        } else if (response.data?.status == '0') {
          message.error('An error occurred. Please try again.');
        }
      } catch (error) {
        if (!isMessageShown) {
          console.error("Error:", error.message);
          message.error('An error occurred. Please try again.');
          isMessageShown = true;
        }
      }
    }
    getUploadFolder();
  }, []);

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");

  }

  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/MedicalRecords");
  };
  const openNewTabHandler = (file, fileType) => {
    setFileType(fileType);
    const sendFiles = { file, fileType, patientUniqueId, id };
    navigate("/fileReader", { state: sendFiles });
  };
  const downloadPdfHandeler = (file, fileType) => {
    const sendFiles = { file, fileType, patientUniqueId, id };
    console.log(sendFiles);
    setFileType(fileType);
    navigate("/fileReader", { state: sendFiles });
  };
  const handleDeleteClickOpen = (id) => {
    setDeleteOpen(true);
    setUploadedDocId(id);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };
  const deleteDocumentsHandler = (e) => {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    setIsDeleteDoc(true);
    e.preventDefault();
    let formdata = $(e.target);
    formdata = new FormData();
    formdata.append("id", uploadedDocId);
    formdata.append('MDT', 'PM');
    formdata.append('user_role', 'rp');

    $.ajax({
      type: "POST",
      url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientMedicalRecord/delete_documents?id=${uploadedDocId}`,
      data: formdata,
      processData: false,
      contentType: false,
      headers: headers,
      success(data) {
        console.log("deleted document response", data);
        // alert("Document deleted");
        setIsDeleteDoc(false);
        setDeleteOpen(false);
        setRefreshUploadedDoc(false);
        window.location.reload(false);
      },
      error(err) {
        if (err.status === 401) {
          // Token expired, show message and log out
          message.error(err.responseJSON.message);
          logoutHandler();
        } else {
          console.error('Error occurred:', err.responseText);
          alert("Error has occurred: ", err.responseText);
        }
      }
    });
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setImg("");
  };
  return (
    <>
      {loading || spinner ? (
        <Spinner />
      ) : (
        <>
          <header className="header">
            <img
              src={back}
              style={{ height: 20, width: 20 }}
              alt="back button"
              onClick={backHandler}
            />
            <h1 className="header-title">Records in folder</h1>
          </header>

          {/* Folder Name - Reduced margin */}
          <div style={{ width: "100%", position: "relative", }}>
            <div style={{ width: "100%", height: "85vh", overflowY: "auto", paddingBottom: "10px", scrollbarWidth: "none", msOverflowStyle: "none", }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  {folderDetails.visiting_purpose} - {folderDetails.doctors_name} (
                  {folderDetails.date})
                </p>
              </div>
              {isLoading ? (
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: "600",
                    color: "green",
                    textAlign: "left",
                  }}
                >
                  Loading...
                </p>
              ) : (
                <>
                  {isNoFile ? (
                    <p
                      style={{
                        color: "red",
                        fontSize: 16,
                        textAlign: "center",
                        fontWeight: "bold",
                        marginTop: 40,
                      }}
                    >
                      No files found
                    </p>
                  ) : (
                    uploadedFile.map((value) => (
                      <div
                        key={value.id}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className="medical-records-cards"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 15px",
                            margin: "5px 0",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            width: "90%", // Adjust to control item width
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexGrow: 1, // This will make the folder div take all remaining space
                            }}
                            onClick={() => {
                              downloadPdfHandeler(value.file, value.document_type);
                            }}
                          >
                            {value.document_type === "application/pdf" ? (
                              <AiFillFilePdf
                                className="doc-image"
                                style={{
                                  borderRadius: 10,
                                  marginRight: 10,
                                }}
                                size={35}
                              />
                            ) : (
                              <FcImageFile
                                className="doc-image"
                                style={{
                                  borderRadius: 10,
                                  marginRight: 10,
                                }}
                                size={35}
                              />
                            )}
                            <div style={{ marginLeft: 5 }}>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  margin: "0",
                                  textAlign: "left",
                                }}
                              >
                                {value.document_name}
                              </p>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#555",
                                  textAlign: "left",
                                }}
                              >
                                {moment(value.create_date_time, "DD/MM/YYYY").format("DD.MM.YYYY")}
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              textAlign: "center",
                              flexShrink: 0, // Prevent the delete div from shrinking
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent triggering download
                              handleDeleteClickOpen(value.id);
                            }}
                          >
                            <img
                              src={deleteicon}
                              alt="Delete Icon"
                              style={{
                                height: "25px",
                                width: "25px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>

                      </div>
                    ))
                  )}
                </>
              )}
            </div>
          </div>

          {/* Add Record Button - Fixed at the bottom */}
          <div
            style={{
              width: "100%",
              padding: "10px 20px",
            }}
          >
            <button
              type="button"
              className="btn btn-primary"
              style={{
                width: "100%",
                fontSize: 18,
                padding: 10,
                borderRadius: 8,
              }}
              onClick={() => navigate("/AddRecords", { state: id })}
            >
              Add Records
            </button>
          </div>

          {/* Delete Confirmation Dialog */}
          <Dialog
            open={deleteOpen}
            onClose={handleDeleteClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure you want to delete this document?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteClose}>Cancel</Button>
              {isDeleteDoc === false ? (
                <form
                  method="post"
                  onSubmit={(event) => deleteDocumentsHandler(event)}
                >
                  <Button type="submit" autoFocus>
                    Delete
                  </Button>
                </form>
              ) : (
                <p
                  style={{
                    color: "red",
                    fontSize: 15,
                    fontWeight: "bold",
                    marginLeft: 10,
                    marginTop: -5,
                  }}
                >
                  Deleting...
                </p>
              )}
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ViewMedicalRecords;
